import React from 'react';

import { css } from '@emotion/css';

import { Typography } from 'components/Typography';

export const EquationSymbol = ({ character }: { character: string }) => (
  <div
    className={css`
      align-self: stretch;
      padding-top: 16px;
    `}
  >
    <Typography type="large">{character}</Typography>
  </div>
);
